/** Toggle incomplete or staging features without removing code. */
export const FEATURE_FLAGS = {
  /** Public /shop catalog, cart, checkout, and payments */
  shop: false,
};

export function isShopEnabled() {
  return FEATURE_FLAGS.shop === true;
}
